

export function flickityAutoScroll(el, flickityOptions = {}) {
	// flickity seems to cause an infinite loop of loading images when they're not loaded yet
	// this is an attempt to limit that to only when all images have loaded fully
	const imgs = [...el.querySelectorAll('img')]
	hasLoaded(imgs, () => {
		setupFlickityAutoScroll(el, flickityOptions)
	})
}


function setupFlickityAutoScroll(el, flickityOptions = {}) {

	if (!window.Flickity) return

	const defaultOptions = {
		prevNextButtons: false,
		pageDots: false,
		draggable: true,
		wrapAround: true,
		selectedAttraction: 0,
		friction: 0.3,
		cellAlign: 'left',
		percentPosition: false,
		imagesLoaded: false,
		lazyLoad: false
	}

	const requiredOptions = {
		autoPlay: false,
		freeScroll: true,
	}

	const flickity = new Flickity(el, {
		...defaultOptions,
		...flickityOptions,
		...requiredOptions
	})

	let isPaused = false
	let tickerSpeed = 1

	const update = () => {
		if (isPaused) return
		if (flickity.slides) {
			flickity.x = (flickity.x - tickerSpeed)
			flickity.settle(flickity.x)
			flickity.selectedIndex = flickity.dragEndRestingSelect()
			flickity.updateSelectedSlide()
			
		}
		window.requestAnimationFrame(update)
	}

	const pause = () => isPaused = true

	const play = () => {
		if (!isPaused) return
		isPaused = false
		window.requestAnimationFrame(update)
	}

	let cancelSlow = null
	let cancelSpeed = null

	const cancel = () => {
		window.cancelAnimationFrame(cancelSpeed)
		window.cancelAnimationFrame(cancelSlow)
	}

	const slow = () => {
		cancel()	
		function reduce() {
			if (tickerSpeed <= 0.33) return
			tickerSpeed -= 0.04
			cancelSlow = window.requestAnimationFrame(reduce)
		}
		reduce()
	}

	const backUpToSpeed = () => {
		cancel()
		function increase() {
			if (tickerSpeed >= 1) return
			tickerSpeed += 0.04
			cancelSpeed = window.requestAnimationFrame(increase)
		}
		increase()
	}

	el.addEventListener('mouseenter', slow, false);
	el.addEventListener('mouseleave', backUpToSpeed, false);

	el.addEventListener('focusin', pause, false);
	el.addEventListener('focusout', play, false);

	flickity.on('dragStart', pause);
	flickity.on('dragEnd', play);
	update()
}


export function hasLoaded(els, callback) {

	if (els.length === 0) return callback()
		
	let loaded = 0
	function checkAll() {
		if (loaded === els.length) callback()
	}
	
	function setLoaded() {
		loaded++
		checkAll()
	}

	function checkImg(el) {
		if (el.complete && el.naturalWidth > 0) { 
			setLoaded()
		} else {
			el.addEventListener('load', () => {
				if (el.naturalWidth > 0) setLoaded()
			}, { once: true })
		}
	}

	function checkVideo(el) {
		if (el.readyState > 2) {
			setLoaded()
		} else {
			function handler(event) {
				if (event.currentTarget.readyState > 2)	{
					el.removeEventListener('readystatechange', handler)
					setLoaded()
				}
			}
			el.addEventListener('readystatechange', handler)
		}
	}

	els.map(el => {
		if (el.nodeName === 'IMG') checkImg(el)
		if (el.nodeName === 'VIDEO') checkVideo(el)
	})
}